import * as React from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Stack
} from '@mui/material'
import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionSummary, {
  AccordionSummaryProps
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import { VariantDetailHGMDInfo } from '@/@core/services/app.service'
import { useTranslation } from 'react-i18next'

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&:before': {
    display: 'none'
  },
  '& .MuiAccordionSummary-root': {
    minHeight: '36px !important'
  }
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={null} {...props} />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-root': {
    minHeight: '36px !important'
  },
  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
    marginLeft: theme.spacing(1)
  }
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)'
}))

const HGMDDetail = React.forwardRef(
  (
    props: {
      predictionValuevalue: {
        key: string
        value: any
      }[]
    },
    ref
  ) => {
    const { t } = useTranslation()
    const data = [
      {
        title: `HGMD`
      }
    ]

    return (
      <Box>
        {data.map((items) => {
          return (
            <Accordion key={items.title} expanded={true}>
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                sx={{
                  cursor: 'default !important'
                }}
              >
                <Stack width={'100%'} direction={'row'} justifyContent="center">
                  {/* <Typography
                    sx={{
                      '::before': {
                        content: '""',
                        display: 'inline-block',
                        width: 4,
                        height: '1.25rem',
                        bgcolor: 'primary.main',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        left: '-10px'
                      },
                      lineHeight: '1.25em',
                      position: 'relative',
                      ml: '10px'
                    }}
                    flex={5}
                  >
                    {items.title}
                  </Typography> */}

                  <Typography
                    sx={{
                      '::before': {
                        content: '""',
                        display: 'inline-block',
                        width: 4,
                        height: '1.25rem',
                        bgcolor: 'primary.main',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        left: '-10px'
                      },
                      lineHeight: '1.25em',
                      position: 'relative',
                      ml: '10px'
                    }}
                    marginLeft={4}
                    flex={7}
                  >
                    {t('Prediction')}
                  </Typography>
                </Stack>
              </AccordionSummary>

              <AccordionDetails>
                <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                  {/* <Box flex={5} sx={{ padding: '10px 5px' }}>
                    {props.hgmdValue.length ? (
                      <TableContainer
                        sx={{
                          minWidth: '100%',
                          width: 'max-content'
                        }}
                      >
                        <Table>
                          <TableBody>
                            {props.hgmdValue.map((item) => {
                              return (
                                <TableRow key={item?.name}>
                                  <TableCell
                                    sx={{
                                      paddingBottom: '8px !important',
                                      paddingTop: '8px !important',
                                      paddingRight: 0
                                    }}
                                  >
                                    {item?.name}
                                  </TableCell>

                                  <TableCell
                                    sx={{
                                      textAlign: 'right',
                                      paddingBottom: '8px !important',
                                      paddingTop: '8px !important',
                                      paddingRight: 0
                                    }}
                                  >
                                    {item?.value}
                                  </TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <Typography textAlign={'center'}>
                        {t('No Results')}
                      </Typography>
                    )}
                  </Box> */}

                  <Box flex={7} sx={{ padding: '10px 5px' }}>
                    <TableContainer
                      sx={{
                        minWidth: '100%',
                        width: 'max-content'
                      }}
                    >
                      <Table>
                        <TableBody>
                          {props.predictionValuevalue.map((item) => {
                            return (
                              <TableRow key={item?.key}>
                                <TableCell
                                  sx={{
                                    paddingBottom: '8px !important',
                                    paddingTop: '8px !important',
                                    paddingRight: 0
                                  }}
                                >
                                  {item?.key}
                                </TableCell>

                                <TableCell
                                  sx={{
                                    textAlign: 'right',
                                    paddingBottom: '8px !important',
                                    paddingTop: '8px !important',
                                    paddingRight: 0
                                  }}
                                >
                                  {item?.value}
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Stack>
              </AccordionDetails>
            </Accordion>
          )
        })}
      </Box>
    )
  }
)

export default HGMDDetail
